export default "__VITE_ASSET__CuCLYRUo__"